export default __webpack_public_path__ + "static/media/center-line.513753db.svg";